import React from 'react';
import { Toggle } from 'components/inputs';

const SoldierItem = ({ soldier, toggleSoldier }) => (
  <div className='SoldierItem sortable-item'>

    <div className='name'>
      <strong>{ soldier.name }</strong><br/>
      <small>
        { soldier.absent
          ? 'Absent'
          : soldier.rank && soldier.rank.name }
      </small>
    </div>

    <div className='enabled'>
      <Toggle noAnimate
        on='Here'
        off='Absent'
        checked={ !soldier.absent }
        onChange={ toggleSoldier( soldier.user_id ) } />
    </div>

  </div>
);

const SoldierList = ({ soldiers, toggleSoldier }) => (
  <div className='SoldierList branded-scrollbar sortable-list'>

    { soldiers.map( ( soldier, index ) => (

      <SoldierItem
        soldier={ soldier }
        key={ `soldier-${ soldier.user_id || index }` }
        toggleSoldier={ toggleSoldier } />

    ) ) }

  </div>
);

export default SoldierList;



// WEBPACK FOOTER //
// ./src/pages/missions/mark/includes/SoldierList.jsx